import React from "react";
import { RxCross2 } from "react-icons/rx";
import Spinner from "../../Loading/Spinner";
import {
  checkoutApplyBtn,
  checkoutInput,
  checkoutLabel,
} from "./checkoutUiClasses";

const Coupon = ({
  coupon,
  setcoupon,
  handleApplyCoupon,
  handleRemoveCoupon,
  CouponLoading,
}) => {
  return (
    <div>
      <label htmlFor="voucher" className={checkoutLabel}>
        Enter a promotional code
      </label>
      <div className="flex gap-2 mb-1">
        <div className="relative flex-1">
          <input
            id="voucher"
            type="text"
            placeholder="Enter promo code"
            className={checkoutInput}
            value={coupon}
            onChange={(e) => setcoupon(e.target.value)}
          />
          {coupon && (
            <RxCross2
              className="absolute right-3 top-1/3 -translate-y-1/2 z-10 cursor-pointer text-[20px] text-white/40 hover:text-white"
              onClick={handleRemoveCoupon}
              aria-label="Clear coupon"
            />
          )}
        </div>
        {CouponLoading ? (
          <button
            type="button"
            disabled
            className={`${checkoutApplyBtn} min-w-[100px] flex items-center justify-center`}
          >
            <Spinner />
          </button>
        ) : (
          <button
            type="button"
            className={checkoutApplyBtn}
            onClick={handleApplyCoupon}
          >
            Apply
          </button>
        )}
      </div>
    </div>
  );
};

export default Coupon;
